import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let block = document.querySelector('.key-figures');



if(block) {
    gsap.set('.figures-wrapper .item', {autoAlpha: 0, y: -50});
    gsap.set('.figures-wrapper .item > *', {autoAlpha: 0, y: -15});

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.figures-wrapper',
            start: 'top 90%',
        }
    });

    tl.to('.figures-wrapper .item', {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: 'power2.out'
    });

    tl.to('.figures-wrapper .item > *', {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.075,
        ease: 'power2.out'
    }, '-=0.3');
}